import common from './locales/pl/common';
import layout from './locales/pl/layout';
import navigation from './locales/pl/navigation';
import auth from './locales/pl/auth';
import onboarding from './locales/pl/onboarding';
import support from './locales/pl/support';
import dashboard from './locales/pl/dashboard';
import statistics from './locales/pl/statistics';
import satisfaction from './locales/pl/satisfaction';
import metrics from './locales/pl/metrics';
import conversations from './locales/pl/conversations';
import settings from './locales/pl/settings';
import documents from './locales/pl/documents';
import businessHours from './locales/pl/businessHours';
import phoneNumbers from './locales/pl/phoneNumbers';
import voices from './locales/pl/voices';
import agents from './locales/pl/agents';
import webchat from './locales/pl/webchat';
import maintenances from './locales/pl/maintenances';
import surveys from './locales/pl/surveys';
import outbound from './locales/pl/outbound';

// Jeden język = jeden obiekt z przestrzeniami nazw (namespaces). Nowy język to nowy katalog
// `locales/<kod>/` i wpis tutaj; typy kluczy nadal biorą się z `pl`, więc brakujący klucz
// w innym języku łatwo złapać `satisfies`.
export const resources = {
  pl: {
    common,
    layout,
    navigation,
    auth,
    onboarding,
    support,
    dashboard,
    statistics,
    satisfaction,
    metrics,
    conversations,
    settings,
    documents,
    businessHours,
    phoneNumbers,
    voices,
    agents,
    webchat,
    maintenances,
    surveys,
    outbound,
  },
} as const;

export const defaultNS = 'common';
export const fallbackLng = 'pl';
export const supportedLngs = ['pl'] as const;
